export default __webpack_public_path__ + "static/media/colorSplotchPremier.3b742409.svg";